import TextInputField from "../InputField";
import type { TextInputFieldProps } from "../InputField/ClientInputField";

const EmailField = ({
  id = "email",
  label = "E-post",
  type = "text",
  valueMissingMessage = "Vennligst legg inn din e-post",
  typeMismatchMessage = "Vennligst legg inn en gyldig e-post",
  required = true,
  ...props
}: Partial<TextInputFieldProps>) => {
  return (
    <TextInputField
      id={id}
      label={label}
      type={type}
      valueMissingMessage={valueMissingMessage}
      typeMismatchMessage={typeMismatchMessage}
      required={required}
      {...props}
    />
  );
};

export default EmailField;
